export class PipelineListTrackers {
  static readonly PIPELINE_TRACKER_PIPELINE_LIST_REFRESH_CLICK =
    '[Pipelines] pipeline list refresh click';

  static readonly PIPELINE_TRACKER_PIPELINE_LIST_CREATE_PIPELINE_CLICK =
    '[Pipelines] pipeline list create pipeline click';

  static readonly PIPELINE_TRACKER_PIPELINE_LIST_PIPELINE_INTRO_CREATE_PIPELINE_CLICK =
    '[Pipelines] pipeline list pipeline intro create pipeline click';

  static readonly PIPELINE_TRACKER_PIPELINE_LIST_PIPELINE_CLICK =
    '[Pipelines] pipeline list pipeline click';
}
